/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useHistory } from 'react-router';
import { useGlobalState } from 'src/core/hooks/useGlobalState';

/**
 * Updates the portal object inside the uiStore whenever the routes change.
 */
export const usePortalUpdater = () => {
    const { uiStore } = useGlobalState();
    const history = useHistory();

    React.useEffect(() => {
        history.listen(() => uiStore.updatePortal());
    }, [history, uiStore]);
};
